import React from 'react';
import { DATA_SOURCE } from '../../constants/governance';

/**
 * Visual indicator showing whether data comes from real API or local fallback.
 * CRITICAL: Investors and Financial pages must NEVER show hardcoded numbers
 * without clearly indicating the data source.
 */
const DataSourceBadge = ({ source, className = '' }) => {
  if (source === DATA_SOURCE.API) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 ${className}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
        Dados reais
      </span>
    );
  }

  if (source === DATA_SOURCE.FALLBACK) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 ${className}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
        Dados locais (fallback)
      </span>
    );
  }

  // EMPTY
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 ${className}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-gray-400" />
      Sem dados
    </span>
  );
};

export default DataSourceBadge;
